define( '../src/sublayouts/m19-data-table/m19-data-table',[ 'jquery', 'lib/utils', 'mask', 'spinner' ], function ( $, utils, Mask, Spinner ) {
    'use strict';

    var M19_sTABLE = function ( $component ) {

        this.$component = $component;

        return this;
    };

    M19_sTABLE.prototype.init = function () {
        var _this = this;
        _this.setTd()

        $(window).on('resize orientationchange', function(){
            if (utils.breakpoint() === 'm' || utils.breakpoint() === 's') {
                _this.setTd()
            }
        });
        $(window).off('m19.reinit').on('m19.reinit', function () {
            _this.init();
        });
    };
    M19_sTABLE.prototype.setTd= function(num) {
        var _this = this,
            $thisRow = _this.$component.find('.m19-table__content-table-row');

            $thisRow.each(function(){
                $(this).find('.fixed-col').css('height',($(this).height()-40));
            })
    }

    return M19_sTABLE;

} );

